import Vue from 'vue';
export default {
    setIsSoftwareCartEmpty: (state, isSoftwareCartEmpty) => state.isSoftwareCartEmpty = isSoftwareCartEmpty,
    setIsHardwareCartEmpty: (state, isHardwareCartEmpty) => state.isHardwareCartEmpty = isHardwareCartEmpty,
    setHasMultilineShipping: (state, hasMultilineShipping) => state.hasMultilineShipping = hasMultilineShipping,
    setCablesInCartCount: (state, cablesInCartCount) => state.cablesInCartCount = cablesInCartCount,
    addOfferToProductsInCart: (state, payload) => {
        for (let offer of state.productsInCart) {
            if (offer.offerName === payload.offerName) {
                offer.quantity += payload.quantity;
                return;
            }
        }
        state.productsInCart.push(payload);
    },
    removeOfferFromProductsInCart: (state, payload) => state.productsInCart = state.productsInCart.filter(offer => offer.offerName !== payload.offerName),
    updateSelectedOfferQuantity: (state, payload) => {
        for (let offer of state.productsInCart) {
            if (offer.offerName === payload.offerName) {
                offer.quantity = payload.quantity;
                offer.cables = payload.cables;
                return;
            }
        }
        
    },
    setProductsInCart: (state, productsInCart) => state.productsInCart = productsInCart,
    setProductCostsInfo: (state, productCostsInfo) => Vue.set(state, 'productCostsInfo', productCostsInfo),
    setHardwareCart: (state, hardwareCart) => state.hardwareCart = hardwareCart,
    setSoftwareCart: (state, softwareCart) => state.softwareCart = softwareCart,
    setRenewalDiscountMatrix: (state, renewalDiscountMatrix) => state.renewalDiscountMatrix = renewalDiscountMatrix
}
